import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core'

import { ApiCreditHistoryService } from '@data/services/modules/credit-history/api-credit-history.service'
import { AuthorizationStatus, TrayItem } from '@data/interfaces/credit-history.interface'
import { STATUS_UI, TRAY_STATUSES, effectiveStatus } from '../../credit-history.labels'
import { AuthService } from '@data/services/modules/auth/auth.service'

/**
 * Bandeja de validaciones del formato de buró (plan v4.2 §9.1, D-32): Legal la atiende y Admin la ve en solo lectura
 * (`credit-history.view-validations`). Por omisión, lo pendiente del más viejo al más nuevo.
 */
@Component({
  selector: 'app-credit-validations-list',
  templateUrl: './validations-list.component.html',
  styleUrls: ['./validations-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditValidationsListComponent implements OnInit {
  items: TrayItem[] = []
  status: AuthorizationStatus = 'pending'
  loading = false
  loadError: string | null = null

  readonly statuses = TRAY_STATUSES
  readonly canValidate: boolean

  private readonly api = inject(ApiCreditHistoryService)
  private readonly cd = inject(ChangeDetectorRef)

  constructor() {
    this.canValidate = inject(AuthService).hasModulePermission('credit-history', 'validate')
  }

  ngOnInit(): void {
    this.load()
  }

  statusOf(item: TrayItem) {
    return STATUS_UI[effectiveStatus(item)]
  }

  setStatus(status: AuthorizationStatus): void {
    if (status === this.status) return
    this.status = status
    this.load()
  }

  load(): void {
    this.loading = true
    this.loadError = null
    this.api.tray(this.status).subscribe((response) => {
      this.loading = false
      if (response.error) {
        this.items = []
        this.loadError = response.status === 403 ? 'No tienes permiso para ver la bandeja de validaciones.' : response.msg
      } else this.items = response.data?.items ?? []
      this.cd.markForCheck()
    })
  }

  trackById(_index: number, item: TrayItem): string {
    return item.id
  }
}
